var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%",
    gradientTransform: "rotate(150 .5 .5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A535C"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "140%",
    height: "140%",
    x: "-20%",
    y: "-20%",
    colorInterpolationFilters: "sRGB",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    baseFrequency: "0.001 0.002",
    result: "turbulence",
    seed: 200,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    in: "turbulence",
    result: "blur",
    stdDeviation: "12 37"
  }), /*#__PURE__*/React.createElement("feBlend", {
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    in: "SourceGraphic",
    in2: "blur",
    mode: "color-dodge",
    result: "blend"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h700v700H0z",
    filter: "url(#b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.bb0c097e8a21e2f4f5b856c14ec44d8b.svg";
export { ForwardRef as ReactComponent };